/**
 * `IdleModals` groups modal/dialog UI. Shows a timeout dialogs on user inactivity and logout.
 */
import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { ButtonConfirm } from '../common/Button/ButtonConfirm';

type LayoutModalsProps = {
  isIdleWarningOpen: boolean;
  isIdleExpiredOpen: boolean;
  onIdleExpiredClose: () => void;
};

const IdleModals = ({
  isIdleWarningOpen,
  isIdleExpiredOpen,
  onIdleExpiredClose
}: LayoutModalsProps): JSX.Element => {
  const { t } = useTranslation();
  const okText = t('general.ok');

  return (
    <>
      <Modal
        isOpen={isIdleWarningOpen}
        aria-labelledby='idle-timeout-warning-title'
        centered>
        <ModalHeader
          id='idle-timeout-warning-title'
          className='modal-header-title'>
          {t('idle-timeout.warning-title')}
        </ModalHeader>
        <ModalBody className='modal-body'>
          {t('idle-timeout.warning-message')}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={isIdleExpiredOpen}
        aria-labelledby='idle-timeout-expired-title'
        centered>
        <ModalHeader
          id='idle-timeout-expired-title'
          className='modal-header-title'>
          {t('idle-timeout.expired-title')}
        </ModalHeader>
        <ModalBody className='modal-body'>
          {t('idle-timeout.expired-message')}
        </ModalBody>
        <ModalFooter className='flex-row button-row'>
          <ButtonConfirm
            name={okText}
            text={okText}
            onClick={onIdleExpiredClose}
          />
        </ModalFooter>
      </Modal>
    </>
  );
};

export default IdleModals;
